import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

interface Props {
  className?: string;
}

const TrackConditionBlack = (props: Props) => {
  const { className } = props;

  return (
    <SvgIcon className={className} viewBox="0 0 284 188.61">
      <circle cx="112.5" cy="9.11" r="8.5" />
      <circle cx="146.5" cy="9.11" r="8.5" />
      <circle cx="180.5" cy="9.11" r="8.5" />
      <circle cx="129.5" cy="52.11" r="8.5" />
      <circle cx="163.5" cy="52.11" r="8.5" />
      <path
        d="M151,251a52,52,0,0,0,52,52h94a52,52,0,0,0,1-104v18a34,34,0,0,1-1,68H203a34,34,0,0,1,0-68h8V199h-8A52,52,0,0,0,151,251Z"
        transform="translate(-108 -155.39)"
      />
      <path
        d="M364.32,182.68A94.19,94.19,0,0,0,315,156.63V175a76.5,76.5,0,0,1-17.5,151h-95A76.5,76.5,0,0,1,194,173.48V155.39A94.5,94.5,0,0,0,202.5,344h95a94.5,94.5,0,0,0,66.82-161.32Z"
        transform="translate(-108 -155.39)"
      />
    </SvgIcon>
  );
};

export default TrackConditionBlack;
